import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { ref, uploadBytes } from "firebase/storage";
import { db, storage } from "@/lib/firebase";

export interface FeedbackInput {
  uid: string;
  weddingId: string | null;
  route: string;
  userAgent: string;
  text: string;
  screenshotPath: string | null;
}

export async function uploadFeedbackScreenshot(uid: string, blob: Blob): Promise<string> {
  const id = crypto.randomUUID();
  const ext = blob.type === "image/jpeg" ? "jpg" : "png";
  const path = `feedback/${uid}/${id}.${ext}`;
  await uploadBytes(ref(storage, path), blob, {
    contentType: blob.type || "image/png",
  });
  return path;
}

export async function submitFeedback(input: FeedbackInput): Promise<string> {
  const docRef = await addDoc(collection(db, "feedback"), {
    uid: input.uid,
    weddingId: input.weddingId,
    route: input.route,
    userAgent: input.userAgent,
    text: input.text,
    screenshotPath: input.screenshotPath,
    createdAt: serverTimestamp(),
  });
  return docRef.id;
}
